import constants from "../constants";
import { useContext, useState } from "react";
import AlertContext from "../context/AlertContext";
import CodingTestHooks from "./CodingPage/CodingTestHooks";
import CodingViewHooks from "./CodingPage/CodingViewHooks";
import MultiLevelDropDownHooks from "./MultiLevelDropDownHooks";
import StudentListHooks from "./StudentListHooks";
import { useParams } from "react-router-dom";

export default function CodingTableHooks() {
  const {
    setTopic,
    testData,
    setStatus,
    setCodingTestData,
    setShowInstruction,
    isAdmin,
    setShowBreadCrumbsData,
    setBreadCrumbsOption,
    setMockTestReportCurrentTopic,
  } = useContext(AlertContext);

  const { viewCode } = CodingViewHooks();
  const { getDataForBreadCrumbsData } = MultiLevelDropDownHooks();
  const { getStudentList } = StudentListHooks();
  const { id } = useParams();

  const { takeTest, resetCCTest } = CodingTestHooks();

  const [expanded, setExpanded] = useState(false);

  const handleChange = (test) => {
    if (handleExpand(test).expand) {
      setExpanded(!expanded);
      setTopic({ id: test.topicid, name: test.topicname });
    } else {
      setExpanded(false);
    }
  };

  const handleExpand = (test) => {
    if (
      !test.showIncompleteTest &&
      (((testData.viewtest === constants.DISPLAY_TEST_RESULT.SUBMISSION ||
        testData.viewtest === constants.DISPLAY_TEST_RESULT.ALL) &&
        test.completedcount === test.totalcount) ||
        ((test.showTakeTest || test.showRetakeTest || test.showResumeTest || test.showRetakeNewVersionTest) &&
          (test.completedcount === 0 ||
            test.completedcount === test.totalcount)) ||
        ((test.showTakeTest || test.showRetakeTest || test.showResumeTest || test.showRetakeNewVersionTest) &&
          (test.completedcount !== 0 ||
            test.completedcount !== test.totalcount) &&
          (testData.viewtest === constants.DISPLAY_TEST_RESULT.NONE ||
            testData.viewtest === constants.DISPLAY_TEST_RESULT.SCORE)))
    ) {
      return {
        expand: false,
        disable: false,
      };
    } else if (
      !test.showIncompleteTest &&
      (test.showTakeTest || test.showRetakeTest || test.showResumeTest || test.showRetakeNewVersionTest) &&
      (test.completedcount !== 0 || test.completedcount !== test.totalcount)
    ) {
      return {
        expand: true,
        disable: false,
      };
    } else {
      return {
        expand: false,
        disable: true,
      };
    }
  };

  const testStatus = (test) => {
    if (test.showIncompleteTest) {
      return constants.PROGRESS_STATUS.IN_PROGRESS;
    } else if (test.showRetakeTest || test.showResumeTest || test.showRetakeNewVersionTest) {
      return constants.PROGRESS_STATUS.QN_CONTINUE;
    } else if (
      test.completedcount >= 0 &&
      test.completedcount < test.totalcount
    ) {
      return constants.PROGRESS_STATUS.UNLOCKED;
    } else if (testData.viewtest === constants.DISPLAY_TEST_RESULT.SCORE) {
      return constants.PROGRESS_STATUS.REATTEMPT;
    } else {
      return constants.PROGRESS_STATUS.EVALUATED;
    }
  };

  const currentTestLabel = (test, isRetake = false) => {
    if (test.showIncompleteTest) {
      return constants.PROGRESS_STATUS.IN_PROGRESS;
    } else if (test.showResumeTest) {
      return constants.PROGRESS_STATUS.QN_CONTINUE;
    } else if (test.showTakeTest) {
      return constants.PROGRESS_STATUS.UNLOCKED;
    } else if (test.showRetakeTest) {
      return constants.PROGRESS_STATUS.REATTEMPT;
    } else if (test.showRetakeNewVersionTest) {
      return constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION;
    } else if (
      testData.viewtest === constants.DISPLAY_TEST_RESULT.ALL ||
      testData.viewtest === constants.DISPLAY_TEST_RESULT.SUBMISSION
    ) {
      return constants.PROGRESS_STATUS.EVALUATED;
    } else if (isRetake) {
      // handling practice retake

      return constants.QUESTION_STATUS.CONTINUE;
    } else {
      return constants.PROGRESS_STATUS.LOCKED;
    }
  };

  const handleCodingTest = (test, status, question, isRetake = false) => {
    if (
      !isRetake &&
      ((question === undefined &&
        (status === constants.PROGRESS_STATUS.UNLOCKED ||
          status === constants.PROGRESS_STATUS.QN_CONTINUE ||
          status === constants.PROGRESS_STATUS.REATTEMPT ||
          status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION)) ||
        (!handleExpand(test).expand &&
          !handleExpand(test).disable &&
          status !== constants.PROGRESS_STATUS.EVALUATED &&
          testData.status !== constants.PROGRESS_STATUS.EVALUATED))
    ) {
      document.documentElement.requestFullscreen();
      test.status = currentTestLabel(test);
      console.log("tests", test);
      
      setCodingTestData(test);
      setStatus(currentTestLabel(test));
      setTopic({ id: test.topicid, name: test.topicname });

      if (testData.testmode === constants.MODE.TEST_MODE) {
        setShowInstruction(true);
      } else {
        takeTest(test);
      }
    } else if (isRetake) {
      // handling practice retake

      document.documentElement.requestFullscreen();
      test.status = currentTestLabel(test);
      setCodingTestData(test);
      setStatus(currentTestLabel(test));
      setTopic({ id: test.topicid, name: test.topicname });
      resetCCTest(test);
    } else {
      if (isAdmin) {
        console.log("testttttttttttData:", testData, "tesssssssssst:", test);
        setShowBreadCrumbsData((prev) => ({
          ...prev,
          learnerId: testData?.learnerid,
          status: constants.QUESTION_STATUS.SUBMITTED,
          testMode:constants.MODE.TEST_MODE,
          mockUse:true,
          lmtid: testData.lmtid,
          lmpid: testData.lmpid,
          testConfigId: test.testconfigid,
          testId: test.qndata[0].testid,
          questionId: test.qndata[0].qnid,
        }));
      }
      viewCode(
        test,
        question !== undefined && "single",
        question,
        testData?.learnerid,
      );
    }
  };

  const testScore = (score) => {
    let marks = 0,
      actualScore = 0;

    for (let i = 0; i < score.length; i++) {
      marks += score[i].marks;
      actualScore += score[i].actualscore;
    }

    return actualScore + "/" + marks;
  };

  return {
    expanded,
    viewCode,
    testScore,
    testStatus,
    handleExpand,
    handleChange,
    currentTestLabel,
    handleCodingTest,
  };
}
